import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-fagui",
  "use": "icon-fagui-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-fagui\"><defs><style type=\"text/css\"></style></defs><path d=\"M853.333333 0a113.777778 113.777778 0 0 1 113.777778 113.777778v796.444444a113.777778 113.777778 0 0 1-113.777778 113.777778H170.666667a113.777778 113.777778 0 0 1-113.777778-113.777778V113.777778a113.777778 113.777778 0 0 1 113.777778-113.777778h682.666666zM260.152889 85.333333H192.739556v853.333334h67.413333v-853.333334z m111.217778 0h-44.942223v853.333334h44.942223v-853.333334z\" fill=\"#ffffff\" p-id=\"1942\" /><path d=\"M789.162667 0v196.551111l-85.674667-101.432889-85.617778 101.432889V0H568.888889v234.609778c0 25.372444 18.375111 50.688 36.693333 50.688l18.375111-12.629334 79.530667-88.746666 79.587556 88.746666a29.980444 29.980444 0 0 0 48.924444-6.371555c4.949333-9.728 7.111111-20.764444 6.144-31.687111V0h-48.924444z\" fill=\"#ffffff\" p-id=\"1943\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/fagui.svg
// module id = Iuw/
// module chunks = 116